import { BlockWrapper, defineBlock, useEditor } from '@smartfire/js-block-engine';
import style from './style.module.scss';
import clsx from 'clsx';

const Block = () => {
    const { isEditing } = useEditor();

    return (
        <BlockWrapper.ChildrenBlocks
            key="children"
            gutenbergEditorConfig={{
                orientation: 'vertical',
                allowedBlocks: ['smartfire/reassurance---item'],
                template: [['smartfire/reassurance---item', {}]],
            }}
            className={clsx(style.block, isEditing ? style.frontend : style.admin)}
        />
    );
};

export default defineBlock({
    Block: Block,
    setup: {
        title: 'Réassurance',
    },
});
